export { default } from './link-rec'
